// extracted by mini-css-extract-plugin
export var base = "SecretLayout-module--base--Y9jXR";
export var hidden = "SecretLayout-module--hidden--Mp1b9";
export var background = "SecretLayout-module--background--9WMqN";
export var loader = "SecretLayout-module--loader--ocbAD";